<template>
  <div id="bm-register">
    <div class="title" >会员注册</div>
    <div class="from" >
      <van-field
        :error-message="validator.ErrMsg.tel"
        v-model="formData.tel"
        clearable
        placeholder="请填写正确有效的手机号">
      </van-field>
      <van-field
        :error-message="validator.ErrMsg.sms"
        v-model="formData.sms"
        type="number"
        placeholder="请输入短信验证码">
        <van-button
          slot="button"
          size="small"
          type="primary"
          @click="getSms()">
          {{ time ? time + 's' : '发送验证码' }}
        </van-button>
      </van-field>
      <van-field
        :error-message="validator.ErrMsg.password"
        v-model="formData.password"
        type="password"
        clearable
        placeholder="请输入6位到16位之间的字符">
      </van-field>
      <!--<van-field-->
        <!--:error-message="validator.ErrMsg.confirmPassword"-->
        <!--v-model="formData.confirmPassword"-->
        <!--type="password"-->
        <!--required clearable label="确认密码"-->
        <!--placeholder="确认密码"-->
      <!--&gt;-->
      </van-field>
      <van-button
        class="btn-reg"
        size="large"
        @click="fromSubmit()"
        :loading="registerLoading" >
        注册</van-button>
      <router-link to="/login" class="style-href" >已有账号</router-link>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
import { sendSmsCode } from '@/api/user'
import ValidatorUtils from '@/libs/validator'
import { Button, Field, CellGroup, Toast } from 'vant'
Vue.use(Button).use(Field).use(CellGroup).use(Toast)

export default {
  name: 'Register',
  data () {
    return {
      sms: '',
      productList: [],
      validator: undefined,
      formData: {
        tel: undefined,
        sms: '',
        password: '',
        confirmPassword: '',
        action: 'sendRegisterCode'
      },
      time: null,
      registerLoading: false,
      rules: {
        password: [
          { required: true, message: '请输入6位到16位之间的密码' },
          {
            validator: (rule, value, callBack) => {
              /^[\w!@#$%^&*]{6,16}$/.test(value) ? callBack() : callBack('请输入6位到16位之间的密码')
            }
          }
        ],
        tel: [
          {
            validator: (rule, value, callBack) => {
              if (!value) {
                callBack('请输入手机号码')
              } else if (/^[1][0-9]{10}$/.test(value)) {
                callBack()
              } else {
                callBack('请输入正确的手机号码')
              }
            }
          }
        ],
        sms: [
          { required: true, message: '请输入4位验证码' },
          {
            validator: (rule, value, callBack) => {
              /^\d{4}$/.test(value) ? callBack() : callBack('请输入4位验证码')
            }
          }
        ]
//        confirmPassword: [
//          { required: true, message: '请再次输入密码' },
//          {
//            validator: (rule, value, callBack) => {
//              value === this.formData.password ? callBack() : callBack('两次密码不一致')
//            }
//          }
//        ]
      }
    }
  },
  created() {
    this.validator = new ValidatorUtils({
      rules: this.rules,
      data: this.formData })
    this.formData = this.validator.Data
  },
  computed: {
    patternTel () {
      return ''
      // return '手机号格式错误'
    }
  },
  mounted () {

  },
  methods: {
    reload() {
      location.reload()
    },
    fromSubmit() {
      this.validator.validate().then(
        (resolve) => {
          this.registerLoading = true
          this.$store.dispatch('SmsLogin', this.formData).then(
            (res) => {
              if (res) {
                Toast({
                  message: '注册成功'
                })
                this.$router.push('evpi')
              }
              this.registerLoading = false
            },
            (rej) => {
              console.log(rej)
              this.registerLoading = false
            }
          )
        },
        (reject) => {
          this.$set(this.validator.errMsg)
          this.registerLoading = false
          return false
        })
    },
    getSms() {
      if (this.time) {
        return
      }
      this.validator.validate('tel').then(
        (res) => {
          sendSmsCode(this.formData.tel).then(
            (resolve) => {
              let sms = resolve.data.isSent
              if (sms) {
                this.countDown()
              }
            },
            (reject) => { console.log(reject) }
          )
        },
        (rej) => {
          this.$set(this.validator, 'tel')
        }
      )
    },
    countDown() {
      this.time = 60
      let date = setInterval(() => {
        if (this.time <= 1) {
          this.time = null
          clearInterval(date)
          return
        }
        this.time -= 1
      }, 1000)
    }
  }
}
</script>

<style>
  #bm-register {
    margin: 0 0.3rem;
  }

  #bm-register .style-href {
    display: block;
    text-align: center;
    padding: 15px;
    font-size: 16px; /*no*/
  }

  #bm-register .van-field__body {
    height: 50px;
    line-height: 50px;
    background:rgba(248,248,248,1);
  }

  #bm-register .van-field__body .van-field__control {
    text-indent: 15px;
    font-size: 16px;
  }

  #bm-register .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #bm-register .van-cell {
    padding: 8px 0;
  }

  #bm-register .van-field__body .van-field__button:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 30px;
    background-color: #CFCFCF;
    top: 10px;
  }

  #bm-register .title {
    font-size: 36px;
    color: #185494;
    font-weight:500;
    text-align: center;
    padding: 15px;
  }

  #bm-register .van-field__body .van-field__button .van-button {
    background-color: transparent;
    border: none;
    color: #185494;
    padding: 0 15px;
  }

  #bm-register .van-field__error-message {
    text-indent: 15px;
  }

  #bm-register .btn-reg {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color: white;
    font-size:20px;
  }

  #bm-register .btn-reg+a {
    color:rgba(129,129,129,1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/register.vue